<section id="ai-assist-manager">
  <app-hamburger-wrapper></app-hamburger-wrapper>
  <app-manager-header [title]="'Kyloe AI Assist Manager'"></app-manager-header>

  @if (clientConfig?.enabled) {
    <section class="content scroll-container">
      <article>
        <h2 class="heading-underline">Prompt Profiles
          @if (clientPromptsDataSource?.data?.length !== 0 && !loading) {
            <span class="clear-input">
              <input class="search-profiles" type="text" (keyup)="filterDataEvent($event)" placeholder="Search all prompt profiles (Ctrl+Shift+F)..." autofocus #searchInput>
              <i [ngClass]="searchInput.value ? 'bhi-times' : 'bhi-search'" class="clear-icon" (click)="clearInput(searchInput, true)" [title]="searchInput.value ? 'Clear' : ''" #clearSearch></i>
            </span>
          }
          <span class="sub-info">
            <span id="createTemplate" (click)='showModal()'>
              Create new Prompt Profile <mat-icon class="add-button" fontIcon="add"></mat-icon>
            </span>
            <span id="adminPage" (click)='showAdminDialog()'>
              <mat-icon fontIcon="settings" class="add-button"  matTooltip="Global AI Assist settings" matTooltipShowDelay="500"></mat-icon>
            </span>
          </span>
        </h2>
        @if (entityTypesUsed.length === 0) {
          <app-skeleton [style]="'tab-filter-buttons'" [flex]="true" [gap]="12" [count]="5"></app-skeleton>
          } <!-- Up the count if we start seeing lots more -->
          @if (entityTypesUsed.length > 0) {
            <mat-button-toggle-group id="entity-filters" name="selectEntity" aria-label="Select entity buttons"
              (change)="filterEntities('entityType', $event.value)" hideSingleSelectionIndicator="true">
              @if (entityTypesUsed) {
                <mat-button-toggle value="" class="view-all"
                  checked="{{!currentEntityFilter}}"
                  (click)="this.clearInput(this.searchInput.nativeElement)">
                  <mat-icon fontIcon="auto_awesome"></mat-icon>
                  View All
                  <aside>{{clientPromptsDataSource.data.length}}</aside>
                </mat-button-toggle>
              }
              @for (entity of entityTypesUsed; track entity) {
                <mat-button-toggle value="{{entity.entityType}}"
                  [ngClass]="[entity.entityType ? entity.entityType.toLowerCase() + '-entity' : '']">
                  <i [ngClass]="bullhornIconService.getIcon(entity.entityType)"></i>
                  {{ getEntityLabel(entity.entityType)}}
                  <aside>{{entity.count}}</aside>
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
          }
          <!-- [hidden] and not *ngIf so table initialises correctly. -->
          <section class="scrollable-container" cdkScrollable>
            <div cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListAutoScrollStep]="10">
              <table mat-table [dataSource]="clientPromptsDataSource" class="table-striped row-highlight"
                matSort #clientPromptsTableSort="matSort">
                <ng-container matColumnDef="entityType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by entity">
                    Entity
                  </th>
                  <td mat-cell *matCellDef="let element" matTooltip = "{{element.entityType}}" matTooltipShowDelay="500">
                    {{ getEntityLabel(element.entityType) }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="displayName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                    Prompt name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.displayName }} </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by action">
                    Action
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.action }} </td>
                </ng-container>
                <!-- TODO temp column. update after feedback -->
                <ng-container matColumnDef="integration">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by action">
                    Integration
                  </th>
                  <td mat-cell *matCellDef="let element"> {{this.getIntegrationValue(element.integration) }} </td>
                </ng-container>
                <ng-container matColumnDef="options">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <aside>
                      <mat-icon fontIcon="content_copy" class="copy-icon" matTooltip="Copy '{{element.displayName}}'" matTooltipShowDelay="500"
                      (click)="duplicateClientPrompt(element, $event)"></mat-icon>
                      <mat-icon  matTooltip="Delete {{element.displayName}}" matTooltipShowDelay="500"
                        class="delete-icon"
                        (click)="delete(element, $event)"
                      fontIcon="delete_outline"></mat-icon>
                      <mat-icon
                        [ngClass]="{'disabled' : (currentEntityFilter)}"
                        fontIcon="drag_indicator" class="drag-icon"
                        [matTooltip]="currentEntityFilter ? 'Reorder this prompt' : 'Prompts can only be reordered when viewing all prompts'"
                        matTooltipShowDelay="500">
                      </mat-icon>
                    </aside>
                  </td>
                  <td mat-cell *matCellDef="let element"> <mat-icon  fontIcon="drag_indicator" [ngClass]="{'disabled' : currentEntityFilter !== undefined}" class="drag-icon"
                    [matTooltip]="!currentEntityFilter ? 'Reorder this prompt' : 'Prompts can only be reordered when viewing all prompts'" matTooltipShowDelay="500">
                  </mat-icon> </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: getDisplayedColumns();"
                  (click)="showModal(row)"
                  [ngClass]="row.enabled ? 'published' : 'unpublished'"
                  [matTooltip]="row.enabled ? '': 'Unpublished Prompt'"
                  [matTooltipPosition]="'above'"
                  matTooltipShowDelay="500"
                  cdkDrag
                [cdkDragDisabled]="currentEntityFilter"></tr>
              </table>
            </div>
            @if ((clientPromptsDataSource?.data?.length === 0 || noResults) && !loading) {
              <div class="no-results">
                @if (clientPromptsDataSource?.data?.length === 0) {
                  <span>NO PROMPT PROFILES, ADD ONE BELOW</span>
                }
                @if (noResults && clientPromptsDataSource?.data?.length !== 0) {
                  <span>NO PROMPT PROFILES FOUND</span>
                }
              </div>
            }
            @if (loading) {
              <app-skeleton [style]="'big-row-table'" [count]="4"></app-skeleton>
            }
          </section>
          <section class="footer-btns">
            <button theme="nav" (click)="showModal()">Create new Prompt Profile<mat-icon class="add-button" fontIcon="add"></mat-icon></button>
            @if (reOrdered) {
              <button theme="nav" (click)="saveProfiles()">Save re-ordering<mat-icon fontIcon="drag_indicator" class="material-icons"></mat-icon></button>
            }
          </section>
        </article>
        <article>
          <!-- TODO: Try and split the tables into a new component -->
          <h2 class="heading-underline">Use a Kyloe created prompt</h2>
          <section class="scrollable-container" cdkScrollable>
            <div>
              <table mat-table [dataSource]="kyloePromptsDataSource" class="table-striped"
                matSort #kyloePromptsTableSort="matSort">
                <ng-container matColumnDef="entityType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by entity">
                    Entity
                  </th>
                  <td mat-cell *matCellDef="let element" matTooltip = "{{element.entityType}}" matTooltipShowDelay="500">
                    {{ getEntityLabel(element.entityType) }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="displayName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                    Prompt name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.displayName }} </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by action">
                    Action
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.action }} </td>
                </ng-container>
                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by role">
                    Role
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.role }} </td>
                </ng-container>
                <ng-container matColumnDef="tone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by tone">
                    Tone
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.tone }} </td>
                </ng-container>
                <ng-container matColumnDef="format">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by format">
                    Format
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.format }} </td>
                </ng-container>
                <ng-container matColumnDef="resultLength">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by result length">
                    Result length
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.resultLength }} </td>
                </ng-container>
                <ng-container matColumnDef="explanationDifficulty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by explanation difficulty">
                    Explanation difficulty
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.explanationDifficulty }} </td>
                </ng-container>
                <ng-container matColumnDef="outputLanguage">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by output language">
                    Output language
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.outputLanguage }} </td>
                </ng-container>
                <ng-container matColumnDef="options">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <aside>
                      <mat-icon fontIcon="add" matTooltip="Add '{{element.displayName}}' to your Prompt Profiles" matTooltipShowDelay="500"
                        class="material-icons" style="cursor: pointer;"
                      (click)="duplicateKyloePrompt(element, $event)"></mat-icon>
                      <button theme="small" (click)="showModal(element)">Try it out</button>
                    </aside>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="getDisplayedKyloeColumns(); sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: getDisplayedKyloeColumns();"></tr>
              </table>
            </div>
            @if ((kyloePromptsDataSource?.data?.length === 0 || noKSPResults) && !loading) {
              <div class="no-results">
                @if (noKSPResults && kyloePromptsDataSource?.data?.length !== 0) {
                  <span>NO PROMPT PROFILES FOUND</span>
                }
              </div>
            }
            @if (loading) {
              <app-skeleton [style]="'big-row-table'" [count]="4"></app-skeleton>
            }
          </section>
        </article>
      </section>
    }
    <div id="version-number" [ngClass]="{'expand-version': expandVersion}" title="Double click to copy - {{environment.environmentIdentifier}} v{{appVersion}}"
      (dblclick)="copyToClipboard(environment.environmentIdentifier + ' v' + appVersion)">
      @if (environment.environmentIdentifier !== 'PROD') {
        ENV: {{ environment.environmentIdentifier }}
      }
      v{{ appVersion }}
    </div>


  </section>
